import React from 'react'
import { useSelector } from 'react-redux'
import {
  MessageContainer,
  Name,
  StyleMessageItemWrapper,
  Time,
  Message,
  TextMessage,
  ImageGrid,
  ChatImage,
} from '../style'
import { StyleAvatar } from '@commons/chats/style'

const MessageItem = ({
  chats = [],
}: {
  chats?: {
    senderId: string
    receiverId: string
    message: string
    time: string
    imgsrc?: string[]
  }[]
}) => {
  const selectedChat = useSelector((state: any) => state.selectedChat)

  return (
    <>
      {chats.map((chat, idx) => {
        const isOwner = chat.senderId === '0'
        const hasText = chat.message?.trim().length > 0
        const hasImages = chat.imgsrc?.length > 0

        return (
          <StyleMessageItemWrapper key={idx} isOwner={isOwner}>
            {!isOwner && <StyleAvatar src={selectedChat?.avatar} />}
            <MessageContainer>
              {!isOwner && <Name>{selectedChat?.name}</Name>}

              {(hasText || hasImages) && (
                <Message
                  isOwner={isOwner}
                  style={{ padding: hasImages ? '12px 12px 8px' : '12px' }}
                >
                  {hasText && (
                    <TextMessage
                      style={{ marginBottom: hasImages ? '8px' : 0 }}
                    >
                      {chat.message}
                    </TextMessage>
                  )}

                  {hasImages && (
                    <ImageGrid count={chat.imgsrc!.length}>
                      {chat.imgsrc!.map((src, i) => (
                        <ChatImage key={i} src={src} alt="" />
                      ))}
                    </ImageGrid>
                  )}
                </Message>
              )}

              <Time>{chat.time}</Time>
            </MessageContainer>
          </StyleMessageItemWrapper>
        )
      })}
    </>
  )
}

export default MessageItem
